import WireframeIcon from "@mui/icons-material/BorderOuter";
import GridHelperIcon from "@mui/icons-material/GridOn";
import SwitchCameraModeIcon from "@mui/icons-material/FilterNone";
import ClippingIcon from "@mui/icons-material/ContentCut";
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import ClippingPanel from "../Viewer3d/ClippingPanel";
import LabelOffIcon from '@mui/icons-material/LabelOff';
import LabelIcon from '@mui/icons-material/Label';
// import LeftFootIcon from '@mui/icons-material/MonochromePhotosOutlined';
import LeftFootIcon from '@mui/icons-material/Splitscreen';
import './Menu.css'
import { useViewerStore } from "context/ViewerContext";
import { useDesignStore } from "context/DesignContext";
import { useEffect, useState } from "react";
import { Box, Slide } from "@mui/material";
import { isDesktop } from "Utils/MediaQueryUtils";

const SideToolbar: React.FC = () => {
  const coloringActive = useViewerStore((state) => state.coloring);
  const wireframeActive = useViewerStore((state) => state.wireframe);
  const gridHelpersActive = useViewerStore((state) => state.grids);
  const perspectiveCameraActive = useViewerStore((state) => state.perspectiveCamera);
  const clippingActive = useViewerStore((state) => state.clipping);
  const feetViewActive = useViewerStore((state) => state.feetView);
  const liveModeActive = useViewerStore((state) => state.liveMode);
  const insoleDesign = useDesignStore((state) => state.insoleDesign);
  
  const [isColoringEnabled, setIsColoringEnabled] = useState(false);
  const [isVisible, setVisible] = useState<boolean>(() => isDesktop());

  useEffect(() => {
    const handleResize = () => {
      setVisible(isDesktop());
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    
    if (insoleDesign?.pressureData || !useDesignStore.getState()?.RondomImageData.some(img=>img == undefined)) {
      setIsColoringEnabled(true);
    } else {
      setIsColoringEnabled(false);
    }
  }, [insoleDesign?.pressureData, useDesignStore.getState().RondomImageData]);

  
  const onFloatingButtonClick = () => {
    setVisible(!isVisible);
  }

  const handleLiveModeClick = () => {
    useViewerStore.getState().setOldLiveMode(useViewerStore.getState().liveMode);
    useViewerStore.getState().toggleLiveMode();
  }

  return (
    <>
      <Box className="side-toolbar-wrapper">
        {/* <button className='side-toolbar-floating-button' onClick={onFloatingButtonClick}>
          <MenuIcon />
        </button> */}
        <Slide in={isVisible} direction='up'>
          <div className="side-toolbar">
            <div className="side-toolbar-group">
              <button
                className={`side-toolbar-button ${!liveModeActive ? "active" : ""}`}
                onClick={handleLiveModeClick}
                data-tour-id="labels"
                title={liveModeActive ? "Hide Labels" : "Show Labels"}
              >
                {liveModeActive ? (
                  <LabelIcon style={{ color: "var(--accent-color-negative)" }} />
                ) : (
                  <LabelOffIcon style={{ color: "var(--accent-color-negative)" }} />
                )}
              </button>
              <button
                className={`side-toolbar-button ${coloringActive ? "active" : ""}`}
                onClick={() => useViewerStore.getState().toggleColoring()}
                data-tour-id="coloring"
                disabled = {!isColoringEnabled}
                title="Toggle Coloring"
              >
                <FormatColorFillIcon />
              </button>
              <button
                className={`side-toolbar-button ${!perspectiveCameraActive ? "active" : ""}`}
                onClick={() => useViewerStore.getState().setPerspectiveCamera(!perspectiveCameraActive)}
                data-tour-id="camera"
                title={`Switch to ${perspectiveCameraActive ? 'Orthographic' : 'Perspective'} Camera`}
              >
                <SwitchCameraModeIcon />
              </button>
              <button
                className={`side-toolbar-button ${wireframeActive !== 'insole' ? "active" : ""}`}
                onClick={() => useViewerStore.getState().cycleWireframe()}
                data-tour-id="wireframe"
                title={`Display Mode: ${wireframeActive}`}
              >
                {wireframeActive === 'insole' && (<WireframeIcon />)}
                {wireframeActive === 'wireframe' && (<WireframeIcon />)}
                {wireframeActive === 'both' && (<WireframeIcon />)}
              </button>
              <button
                className={`side-toolbar-button ${clippingActive ? "active" : ""}`}
                onClick={() => useViewerStore.getState().toggleClipping()}
                data-tour-id="clipping"
                title="Clipping"
              >  
                <ClippingIcon /> 
              </button>
              <button
                className={`side-toolbar-button ${gridHelpersActive ? "active" : ""}`}
                onClick={() => useViewerStore.getState().toggleGrids()}
                data-tour-id="grid"
                title="Grid Helpers"
              >
                <GridHelperIcon />
              </button>
              <button
              className={`side-toolbar-button ${feetViewActive !== 'both' ? 'active' : ""}`}
              onClick={() => useViewerStore.getState().cycleFeetView()}
                data-tour-id="feet-view"
              title={`Feet View: ${feetViewActive}`}
              >
              {feetViewActive === 'left' && (<LeftFootIcon style={{ transform: 'rotate(90deg)' }} />)}
              {feetViewActive === 'right' && (<LeftFootIcon style={{ transform: 'rotate(90deg)' }} />)}
              {feetViewActive === 'both' && (<LeftFootIcon style={{ transform: 'rotate(90deg)' }} />)}
            </button>
            </div>
          </div>
        </Slide>
      </Box>
      {clippingActive && <ClippingPanel axis="z" />}
      {clippingActive && <ClippingPanel axis="x"/>}
    </>
  );
};

export default SideToolbar;
